import { Controller } from "@hotwired/stimulus"

const COMPLETED_STORIES_KEY = 'completedStories'
const SCROLL_POSITIONS_KEY = 'storyScrollPositions'

export default class extends Controller {
  static values = {
    bookId: Number,
    storyId: Number
  }

  connect() {
    const savedPosition = this.loadScrollPosition()
    if (savedPosition > 0) {
      requestAnimationFrame(() => {
        window.scrollTo({ top: savedPosition, behavior: 'instant' })
      })
    }

    this.scrollHandler = this.debounce(() => {
      this.saveScrollPosition()
    }, 1000)
    window.addEventListener('scroll', this.scrollHandler)

    this.beforeUnloadHandler = () => {
      this.saveScrollPosition()
    }
    window.addEventListener('beforeunload', this.beforeUnloadHandler)

    this.checkCompletionHandler = this.debounce(() => {
      this.checkCompletion()
    }, 500)
    window.addEventListener('scroll', this.checkCompletionHandler)

    requestAnimationFrame(() => {
      this.checkCompletion()
    })
  }

  disconnect() {
    this.saveScrollPosition()
    window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('beforeunload', this.beforeUnloadHandler)
    window.removeEventListener('scroll', this.checkCompletionHandler)
  }

  get storageKey() {
    return `${this.bookIdValue}-${this.storyIdValue}`
  }

  saveScrollPosition() {
    const positions = this.getScrollPositions()
    positions[this.storageKey] = window.scrollY
    localStorage.setItem(SCROLL_POSITIONS_KEY, JSON.stringify(positions))
  }

  loadScrollPosition() {
    const positions = this.getScrollPositions()
    return positions[this.storageKey] || 0
  }

  getScrollPositions() {
    const stored = localStorage.getItem(SCROLL_POSITIONS_KEY)
    return stored ? JSON.parse(stored) : {}
  }

  checkCompletion() {
    const article = this.element.querySelector('article')
    if (!article) return

    const articleRect = article.getBoundingClientRect()
    const windowHeight = window.innerHeight

    if (articleRect.bottom <= windowHeight + 100) {
      this.markAsCompleted()
    }
  }

  markAsCompleted() {
    if (this.hasMarkedCompleted) {
      return
    }

    this.hasMarkedCompleted = true

    const completed = this.getCompletedFromLocalStorage()
    if (!completed.includes(this.storageKey)) {
      completed.push(this.storageKey)
      localStorage.setItem(COMPLETED_STORIES_KEY, JSON.stringify(completed))
    }
  }

  getCompletedFromLocalStorage() {
    const stored = localStorage.getItem(COMPLETED_STORIES_KEY)
    return stored ? JSON.parse(stored) : []
  }

  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}
